import React from "react";

const Tab = ({ label, onClick, isActive } :
                 {label: any, onClick: any, isActive : boolean}) => (
    <button
        type="button"
        className={`tab ${isActive ? "active" : ""}`}
        onClick={onClick}
    >
        {label}
    </button>
);

export default Tab;